import React, { useEffect, useState } from 'react';
import './css/CatalogFrame.scss';
import SplitPane, { Pane } from 'react-split-pane';
import SearchResults from './search/SearchResults';
import SearchFacets from './search/SearchFacets';
import TablesOfContents from './catnav/TablesOfContents';
import $ from 'jquery';
import { FrameContents } from './FrameContents';
import { useBiblStore } from './hooks/useBiblStore';
import MandalaSkeleton from '../views/common/MandalaSkeleton';
import jsonpAdapter from './common/axios-jsonp';
import axios from 'axios';
import { NavSearch } from './search/NavSearch';
import { useCatSearchStore } from './hooks/useCatSearchStore';
import { useCatSolr } from './hooks/useCatSolr';

/**
 * CatalogFrame displays all parts of the catalog. It is a split pane with the content on the left and
 * a TOC on the right. The TOC is the catalog TOC when looking at bibl records or a text's sections TOC
 * when looking at a text. There is a variable below for "biblcontent" which is the content for the main,
 * content section of the frame. There are two tabs for the catalog or texts TOC on the right.
 *
 * @returns {JSX.Element}
 * @constructor
 */
export default function CatalogFrame({ search = false }) {
    const { collInfo, setCollInfo } = useBiblStore();
    const catSearchStore = useCatSearchStore();
    const [collsLoaded, setCollsLoaded] = useState(false);

    const [dragged, setDragged] = useState(false); // Drag state for split screen view

    const query = {
        q: `subtype:(collection edition)`,
        fq: ['type:tibbibl'],
        fl: '*',
        rows: 1000,
    };

    const {
        isLoading: isCollInfoLoading,
        data: newCollInfo,
        isError: isCollInfoError,
        error: collInfoError,
    } = useCatSolr(query);

    useEffect(() => {
        //console.log('new collinfo', newCollInfo);
        setCollInfo(newCollInfo);
        setCollsLoaded(true);
    }, [newCollInfo]);

    if (!collsLoaded) {
        return <MandalaSkeleton />;
    }

    const startDrag = () => {
        setDragged(true);
    };
    const endDrag = () => {
        setDragged(false);
        $('.Pane1 .l-frame-wrapper').width($('.Pane1').width());
        // console.log("pane 1 width: " + $('.Pane1').width(), $('.Pane1'));
    };

    return (
        <>
            <SplitPane
                split="vertical"
                primary="second"
                className="l-catalog-frame"
                defaultSize="25vw"
                allowResize={true}
                /* defaultSize={search ? '15vw' : '35vw'}
                allowResize={!search}*/
                onDragStarted={startDrag}
                onDragFinished={endDrag}
            >
                <Pane id="catalog-sp-1" className="l-frame-content">
                    <div className="l-frame-wrapper">
                        {!search && <FrameContents />}
                        {search && <SearchResults />}
                        {/*
                        {!catSearch?.isNew && framecontent}
                        {catSearch?.isNew && <SearchResults />} */}
                    </div>
                </Pane>
                <Pane id="catalog-sp-2" className="l-frame-toc">
                    <div className="l-frame-wrapper" id="catalog-sp-wrapper">
                        {/*<h1 className="h4 mt-1 font-italic">{edhead}</h1>*/}
                        {!search && <TablesOfContents />}
                        {search && (
                            <>
                                <NavSearch /> <SearchFacets />
                            </>
                        )}
                        {/*{tocType === 'facets' && <SearchFacets />} */}
                    </div>
                </Pane>
            </SplitPane>
        </>
    );
}

export async function getCatalogInfo() {
    const params = {
        q: `subtype:(collection edition)`,
        fq: ['type:tibbibl'],
        fl: '*',
        rows: 1000,
    };
    let request;
    try {
        request = {
            url: process.env.REACT_APP_SOLR_URL,
            headers: {
                'Content-Type': null,
            },
            params: params,
        };
        return await axios.request(request);
    } catch (e) {
        console.error('could not fetch coll data', {
            error: e,
            base: process.env.REACT_APP_SOLR_URL,
            params: params,
            url: e.request?.responseURL,
        });
    }
}
